/*
 *  -----------------------------------------------------------------------
 *    <copyright file="login.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Settings from 'settings/settings';
import { Logger } from 'utils/logger';

export default async (orgCode: string) => {
    Logger.log(`Getting organisation details: ${orgCode}`);
    let errorMessage = null;

    const response = await fetch(
        orgCode
            ? `${Settings.api.url()}/api/login/organisation/${orgCode}`
            : `${Settings.api.url()}/api/login/organisation`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        },
    ).catch((error) => {
        Logger.error(`Exception getting organisation details: ${error.message}`);
        errorMessage = error.message;
    });

    if (errorMessage || !response) return { error: errorMessage };

    try {
        return await response.json();
    } catch (error: any) {
        return { error: error.message };
    }
};
